import {
  formatAddonPriceLabel,
  getCatalogAddonPrice,
  isFreeAppointmentAddon,
} from './index';

/**
 * Build add-on checkbox choices for Pat's Portal appointment edit.
 * No session-length or stacking restrictions — MTs can select any offered add-on.
 */
export const buildAddonChoicesWithCombinationState = (
  locationAddons,
  _selectedIds,
  _serviceDuration,
  options = {},
) => {
  if (!Array.isArray(locationAddons)) return [];

  const { hasMembership = false } = options;

  return locationAddons.map(addon => {
    const label = addon?.addon_type?.label || addon?.addon_type?.name || '';
    const isFree = isFreeAppointmentAddon(addon, locationAddons);
    const price = getCatalogAddonPrice(addon, hasMembership);

    return {
      id: addon.id,
      name: label,
      tier: isFree ? 'free' : 'premium',
      price,
      priceLabel: isFree ? 'Included' : formatAddonPriceLabel(price),
      disabled: false,
      disabledReason: null,
    };
  });
};
